import { API_BASE_URL } from "utils/constants";

const PermissionManagementPaths = {
  get_group_permission: `${API_BASE_URL}/common/group-permission`,

  get_option_permission: `${API_BASE_URL}/common/option-permission`,

  add_group_permission: `${API_BASE_URL}/common/add-group-permission`,

  update_group_permission: `${API_BASE_URL}/common/update-group-permission`,

  delete_group_permission: `${API_BASE_URL}/common/delete-group-permission`,
};

export default PermissionManagementPaths;
